const removeTableRow = (id) => {
  const row = document.querySelector(`.row-${id}`);
  if (row) {
    row.style.opacity = "0";
    row.addEventListener("transitionend", () => row.remove());
  }
};

export { removeTableRow };
